<template>
  <g-popup title="Account ID" :background-click="false" :width="width">
    <template #body>
      <div v-for="item in array">
        <span class="--wrapper -font-size-12 -color-gray-1">{{item}}</span><br/>
      </div>
    </template>
    <template #footer>
      <g-button variant="primary" @click="onClickConfirm"><span>확인</span></g-button>
    </template>
  </g-popup>
</template>

<script>
export default {
  props: {
    instKey: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      defalut: () => () => {}
    },
    onCancel: {
      type: Function,
      defalut: () => () => {}
    }
  },
  methods: {
    onClickConfirm () {
      this.$popupManager.close(this.instKey)
      if (this.onConfirm) {
        this.onConfirm()
      }
    },
    onClickCancel () {
      this.$popupManager.close(this.instKey)
      if (this.onCancel) {
        this.onCancel()
      }
    }
  },
  data() {
    return {
      array : []
      , width: 0
    }
  },
  mounted() {
    this.array = this.text.split(",")
    // alert(this.array[0].length + '  ' + this.array[0])
    if(this.array[0].length < 20) {
      this.width = 300
    } else {
      this.width = 500
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/contract/components/components/ServiceIdsPopid.vue